import asterra1 from "./asterra (1).png";
import asterra2 from "./asterra (2).png";
import asterra3 from "./asterra (3).png";

const asteraImage = [asterra1, asterra2, asterra3];

export default asteraImage;
